// extracted by mini-css-extract-plugin
export default {"collection":"Collection_collection__8AI2I","container":"Collection_container__H4Fj7","list":"Collection_list__b99yb"};